"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChipDenomination = exports.UiButtonType = exports.PlayerControls = exports.RoundResult = exports.RoundState = exports.PileId = exports.CardDisclosureStatus = exports.CardType = exports.CardSuit = void 0;
var CardSuit;
(function (CardSuit) {
    CardSuit[CardSuit["Club"] = 0] = "Club";
    CardSuit[CardSuit["Spade"] = 1] = "Spade";
    CardSuit[CardSuit["Heart"] = 2] = "Heart";
    CardSuit[CardSuit["Diamond"] = 3] = "Diamond";
})(CardSuit || (exports.CardSuit = CardSuit = {}));
var CardType;
(function (CardType) {
    CardType[CardType["Ace"] = 1] = "Ace";
    CardType[CardType["Two"] = 2] = "Two";
    CardType[CardType["Three"] = 3] = "Three";
    CardType[CardType["Four"] = 4] = "Four";
    CardType[CardType["Five"] = 5] = "Five";
    CardType[CardType["Six"] = 6] = "Six";
    CardType[CardType["Seven"] = 7] = "Seven";
    CardType[CardType["Eight"] = 8] = "Eight";
    CardType[CardType["Nine"] = 9] = "Nine";
    CardType[CardType["Ten"] = 10] = "Ten";
    CardType[CardType["Jack"] = 11] = "Jack";
    CardType[CardType["Queen"] = 12] = "Queen";
    CardType[CardType["King"] = 13] = "King";
})(CardType || (exports.CardType = CardType = {}));
var CardDisclosureStatus;
(function (CardDisclosureStatus) {
    CardDisclosureStatus[CardDisclosureStatus["None"] = 0] = "None";
    CardDisclosureStatus[CardDisclosureStatus["Pending"] = 1] = "Pending";
    CardDisclosureStatus[CardDisclosureStatus["PendingHidden"] = 2] = "PendingHidden";
    CardDisclosureStatus[CardDisclosureStatus["InProgress"] = 3] = "InProgress";
    CardDisclosureStatus[CardDisclosureStatus["Completed"] = 4] = "Completed";
})(CardDisclosureStatus || (exports.CardDisclosureStatus = CardDisclosureStatus = {}));
var PileId;
(function (PileId) {
    PileId[PileId["Deck"] = 0] = "Deck";
    PileId[PileId["Player1"] = 1] = "Player1";
    PileId[PileId["Player2"] = 2] = "Player2";
    PileId[PileId["Player3"] = 3] = "Player3";
    PileId[PileId["Player4"] = 4] = "Player4";
    PileId[PileId["Croupier"] = 5] = "Croupier";
    PileId[PileId["Waste"] = 6] = "Waste";
})(PileId || (exports.PileId = PileId = {}));
var RoundState;
(function (RoundState) {
    RoundState[RoundState["Loading"] = 0] = "Loading";
    RoundState[RoundState["Deal"] = 1] = "Deal";
    RoundState[RoundState["Dealing"] = 2] = "Dealing";
    RoundState[RoundState["Controls"] = 3] = "Controls";
    RoundState[RoundState["Transition"] = 4] = "Transition";
    RoundState[RoundState["Result"] = 5] = "Result";
    RoundState[RoundState["Continue"] = 6] = "Continue";
    RoundState[RoundState["Finish"] = 7] = "Finish";
})(RoundState || (exports.RoundState = RoundState = {}));
var RoundResult;
(function (RoundResult) {
    RoundResult[RoundResult["Push"] = 0] = "Push";
    RoundResult[RoundResult["CroupierWin"] = 1] = "CroupierWin";
    RoundResult[RoundResult["PlayerWin"] = 2] = "PlayerWin";
    RoundResult[RoundResult["PlayerBust"] = 3] = "PlayerBust";
    RoundResult[RoundResult["PlayerBlackjack"] = 4] = "PlayerBlackjack";
})(RoundResult || (exports.RoundResult = RoundResult = {}));
var PlayerControls;
(function (PlayerControls) {
    PlayerControls[PlayerControls["Stand"] = 0] = "Stand";
    PlayerControls[PlayerControls["Split"] = 1] = "Split";
    PlayerControls[PlayerControls["Double"] = 2] = "Double";
    PlayerControls[PlayerControls["Hit"] = 3] = "Hit";
})(PlayerControls || (exports.PlayerControls = PlayerControls = {}));
var UiButtonType;
(function (UiButtonType) {
    UiButtonType[UiButtonType["Clear"] = 0] = "Clear";
    UiButtonType[UiButtonType["AllIn"] = 1] = "AllIn";
    UiButtonType[UiButtonType["Deal"] = 2] = "Deal";
    UiButtonType[UiButtonType["Stand"] = 3] = "Stand";
    UiButtonType[UiButtonType["Double"] = 4] = "Double";
    UiButtonType[UiButtonType["Split"] = 5] = "Split";
    UiButtonType[UiButtonType["Hit"] = 6] = "Hit";
    UiButtonType[UiButtonType["Continue"] = 7] = "Continue";
})(UiButtonType || (exports.UiButtonType = UiButtonType = {}));
var ChipDenomination;
(function (ChipDenomination) {
    ChipDenomination[ChipDenomination["Chip10"] = 10] = "Chip10";
    ChipDenomination[ChipDenomination["Chip50"] = 50] = "Chip50";
    ChipDenomination[ChipDenomination["Chip100"] = 100] = "Chip100";
    ChipDenomination[ChipDenomination["Chip500"] = 500] = "Chip500";
    ChipDenomination[ChipDenomination["Chip1k"] = 1000] = "Chip1k";
    ChipDenomination[ChipDenomination["Chip5k"] = 5000] = "Chip5k";
    ChipDenomination[ChipDenomination["Chip10k"] = 10000] = "Chip10k";
    ChipDenomination[ChipDenomination["Chip50k"] = 50000] = "Chip50k";
    ChipDenomination[ChipDenomination["Chip100k"] = 100000] = "Chip100k";
})(ChipDenomination || (exports.ChipDenomination = ChipDenomination = {}));
